// utils
import { timezones } from '../../../utils/format';
// styles
import { DefaultTheme } from 'styled-components';
// apis
import { getSensorError } from '../../../apis';

// ----------------------------------------------------------------------

interface Props {
  row: {
    iotDeviceId: string;
    iotGroupName: string;
    location: string;
    serialNumber: string;
    noSignal: boolean;
    rsrp: number;
    waterQualitySensorErrorCount: number;
    lowBattery: boolean;
    batteryLevel: number;
    boardTemperature: number;
    enabled: boolean;
    acquisitionAt: string;
  };
  theme: DefaultTheme;
  setDialog: React.Dispatch<React.SetStateAction<any>>
};

// ----------------------------------------------------------------------

export default function TableRow({ row, theme, setDialog }: Props){
  const date = row.acquisitionAt ? timezones(row.acquisitionAt, 'YYYY-MM-DD HH:mm:ss') : '';

  const handleSensors = async () => {
    await getSensorError(setDialog, row.iotDeviceId);
  };
  
  return (
    <tr>
      <td>{row.iotGroupName}</td>
      <td>{row.location}</td>
      <td>{row.serialNumber}</td>
      <td>{ row.noSignal ? '신호 없음' : '정상' }</td>
      <td>{row.rsrp}</td>
      <td>
        <button type='button' onClick={() => handleSensors()}>{row.waterQualitySensorErrorCount}</button>
      </td>
      <td style={{ color: row.lowBattery && theme.colors.yellow }}>{row.batteryLevel}</td>
      <td>{row.boardTemperature}</td>
      <td>{ row.enabled === null ? '' : row.enabled ? '사용' : '사용 안 함' }</td>
      <td>{ date }</td>
    </tr>
  );
}